import VueRouter from 'vue-router';
import Vue from 'vue';
Vue.use(VueRouter);

import routes from './routes';
import store from '../store/store';
import axios from 'axios';

let router = new VueRouter(
  { 
    mode: 'history', 
    routes: routes, 
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  }
);

router.afterEach((to, from, next) => {
  if(store.state.protocolHash && from.name) {
    store.commit("saveProtocolToServer", "");
  }
})

export default router